<div class="tr hover layout-row layout-align-start-center agent-inventory-settings-row">

  <!--Package Type-->
  <div class="flex-30 td medium layout-row layout-align-start-center">
    <app-bringoz-package-item flex [id]="setting.packageType">

    </app-bringoz-package-item>
  </div>

  <!--Package ID-->
  <div class="flex td large layout-column layout-align-start-start">
    <span class="br-body-2">{{setting.packageId || '---'}}</span>
  </div>

  <!--Agent Skills-->
  <div class="flex td large layout-column layout-align-start-start">
    <div class="layout-row layout-align-start-center">
      <app-skill-tags [skillsIds]="setting.skills" [limit]="5"></app-skill-tags>
      <span *ngIf="!setting.skills?.length" class="br-body-2 color-secondary-201">---</span>
    </div>
  </div>

  <!--Inventory Limit / Quantity-->
  <div class="flex-10 td small layout-row layout-align-start-center">
    <span class="br-body-2">{{setting.quantity}}</span>
  </div>

  <!--Actions-->
  <div class="td xsmall layout-row layout-align-center-center gap-5">
    <bringoz-button type="tertiary"
                    size="fit"
                    (onClick)="onEdit.emit($event)">
      <bringoz-icon iconName="edit-outline"></bringoz-icon>
    </bringoz-button>
    <bringoz-button type="tertiary"
                    size="fit"
                    (onClick)="onRemoveRow($event)">
      <bringoz-icon iconName="trash"></bringoz-icon>
    </bringoz-button>
  </div>

</div>
